(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ea-testimonials"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCarousel(section) {
    var container = section.closest('.ea-testimonials__container');
    var slides = section.querySelectorAll('[data-testimonial-slide]');
    var dots = container ? container.querySelectorAll('[data-testimonial-dot]') : [];
    var prevBtn = section.querySelector('[data-testimonial-prev]');
    var nextBtn = section.querySelector('[data-testimonial-next]');
    var current = 0;
    var total = slides.length;
    var touchStartX = 0;
    var touchEndX = 0;

    if (total <= 1) return;

    function goTo(index) {
      if (index < 0) index = total - 1;
      if (index >= total) index = 0;

      slides[current].classList.remove('ea-testimonials__slide--active');
      if (dots[current]) dots[current].classList.remove('ea-testimonials__dot--active');

      current = index;

      slides[current].classList.add('ea-testimonials__slide--active');
      if (dots[current]) dots[current].classList.add('ea-testimonials__dot--active');
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(this.dataset.testimonialDot, 10));
      });
    });

    /* Touch/swipe support for mobile */
    var track = section.querySelector('[data-testimonial-track]');
    if (track) {
      track.addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      track.addEventListener('touchend', function (e) {
        touchEndX = e.changedTouches[0].screenX;
        var diff = touchStartX - touchEndX;
        if (Math.abs(diff) > 50) {
          if (diff > 0) goTo(current + 1);
          else goTo(current - 1);
        }
      }, { passive: true });
    }
  }

  /* Init all instances on the page */
  function init() {
    document.querySelectorAll('[data-testimonial-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Support Shopify theme editor live reload */
  if (Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var section = e.target.querySelector('[data-testimonial-carousel]');
      if (section) initCarousel(section);
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
